export default "__VITE_ASSET__DCq$g4cY__"